import { Box, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { changeUsersPlan } from 'src/redux/actions/User'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ChangeUserPlanDialog = ({
    currentPlanId,
    open,
    setOpen,
    userId
}) => {
    const dispatch = useDispatch()

    const { t } = useTranslation()

    const [choosedPlan, setChoosedPlan] = useState('')

    useEffect(() => {
        if(currentPlanId) {
            setChoosedPlan(currentPlanId)
        }
    }, [currentPlanId])

    const { plans } = useSelector((state) => state.Plan);

    const confirmPlanChange = () => {
        dispatch(changeUsersPlan(userId, choosedPlan))
        setOpen(false)
    }

    return (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
            <DialogTitle>{t("views.customerDataManagement.changeUserPlan")}</DialogTitle>
            <DialogContent sx={{
                display: 'flex',
                flexDirection: "column",
                alignItems: "center",
                gap: "20px"
            }}>
                <DialogContentText sx={{
                    alignSelf: "start"
                }}>{t("views.customerDataManagement.planNotLinkedInfo")}</DialogContentText>
                {/* <Typography textAlign="center">{t("views.customerDataManagement.chooseOption")}</Typography> */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}>
                    <FormControl sx={{ mt: 1, minWidth: 120 }} size="small">
                        <InputLabel id="plan-choose-dropdown-label">Plan</InputLabel>
                        <Select
                            labelId="plan-choose-dropdown-label"
                            id="plan-choose-dropdown"
                            value={choosedPlan}
                            label="Plan"
                            onChange={(e) => setChoosedPlan(e.target.value)}
                        >
                            <MenuItem value=""><em>{t("views.customerDataManagement.choose")}</em></MenuItem>
                            {plans.filter(p => p.planType == 'plan').map(plan => {
                                return (
                                    <MenuItem key={plan._id} value={plan._id}>{plan.name}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '10px'
                }}>
                    <Typography variant='body1'>{t("views.customerDataManagement.selectedPlan")}</Typography>
                    <Typography variant="body1" fontWeight="600">{plans.find(p => p._id == choosedPlan) ? plans.find(p => p._id == choosedPlan)?.name  : '-'}</Typography>
                </Box>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '20px'
                }}>
                    <Button size="small" variant="contained" color="error" onClick={() => setOpen(false)}>{t("views.customerDataManagement.close")}</Button>
                    <Button size="small" variant="contained" disabled={choosedPlan == currentPlanId ? true : false} onClick={confirmPlanChange}>{t("views.customerDataManagement.change")}</Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default ChangeUserPlanDialog
